import {createContext, useContext} from 'react'

export const BasenameContext = createContext<{basename?: string}>({})

export const BasenameProvider = BasenameContext.Provider

export function useBasename() {
  const context = useContext(BasenameContext)
  if (!context) {
    throw new Error('useBasename must be used within a BasenameProvider')
  }
  return context
}
